import React, { Component } from "react"

import { MAX_LENGTH_QUERYSET_VIZ_CAP } from "shared/imports/sharedConstants"

import genericVisualizationScene, {
    genericBarPieScene,
    genericLineScene,
    genericMapScene,
    genericNetworkScene,
    genericWordCloudScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import {
    NoteInvolvingSupporterFilter,
} from "shared/search/containers/Filter/NoteFilters"

import {
    GrassrootsActionTypeFilter,
    GrassrootsActionSourceFilter,
} from "shared/search/containers/Filter/GrassrootsActionFilters"

/* *****************************************************************
* MAPS
******************************************************************* */

/* *****************************************************************
* BAR / PIE COMBO GRAPHS
******************************************************************* */
export class GrassrootsActionTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'gaTypeBarPieScene',
        filterId: GrassrootsActionTypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'typeFrequency',
        label: "Types",
        icon: "fa-pencil-square-o",
        sidebarTableLabel: "Action Type",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class GrassrootsActionSupporterBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'gaSupporterBarPieScene',
        filterId: NoteInvolvingSupporterFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'contactFrequency',
        label: "Participants",
        icon: "fa-child",
        permissions: [DjangIO.app.models.PermissionType.custom_contacts],
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP,
        sidebarTableLabel: "Participants",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class GrassrootsActionSourceBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'gaSourceBarPieScene',
        filterId: GrassrootsActionSourceFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'sourceFrequency',
        label: "Sources",
        icon: "fa-check",
        sidebarTableLabel: "Action Source"
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

/* *****************************************************************
* LINE GRAPH (TREND)
******************************************************************* */
